
import { defineComponent, ref } from 'vue'

export default defineComponent({
  props: {
    id: {
      type: String,
      required: true
    }
  },
  setup(props, { emit }) {
    const fileInput = ref<null | HTMLInputElement>(null)

    function handleFileBrowsing(e: Event) {
      const fileList = (e.target as HTMLInputElement).files
      if(fileList) {
        const files = [...fileList].map(item => item)
        emit('filesSelected', files)
        if(fileInput.value) {
          fileInput.value.value = ''
        }
      }
    }

    return {
      fileInput,
      handleFileBrowsing
    }
  }
})
